'use client';

import * as React from 'react';
import { PRICING_LINK } from '../shared';
import { useSetWindowLocation } from '../../hooks/navigation/useSetWindowLocation';
import { useForwardSearchParams } from '../../hooks/navigation/useForwardSearchParams';
import { campaignActive, isCampaignActive } from '../../content/referral';
import styles from './TopArtistSection.module.css';

export const TopArtistSection = ({
  name,
  code,
  banner,
  link = PRICING_LINK,
}: {
  name: string;
  code?: string;
  banner?: string | undefined | null;
  link?: string;
}) => {
  const fallbackImage = '/web_bg.png';
  const setWindowLocation = useSetWindowLocation();
  const forwardParams = useForwardSearchParams();

  const handleClick = () => {
    const url = new URL(forwardParams(link));
    if (code) url.searchParams.set('affiliate', code);
    setWindowLocation(url.toString());
  };

  return (
    <div className={styles.container}>
      {}
      <div
        className={styles.backgroundImageAndGradients}
        style={{ backgroundImage: `url(${banner ?? fallbackImage})` }}
      />

      <div className={`${styles.content} u-grid`}>
        <div>
          <h1 className={styles.title}>
            {name ? `You’ve been invited by ${name}` : 'You’re invited'}.
          </h1>
          <h2 className={styles.subTitle}>
            {isCampaignActive()
              ? campaignActive.invitePageDescription
              : `Measure the impact of food, activity, stress and sleep on your body using glucose biomarkers. Track your metabolic health with Ultrahuman M1.`}
          </h2>
          <button className={styles.styledButton} onClick={handleClick}>
            {/* {isCampaignActive() ? 'Shop the offer' : 'Order now'} */}
            Order now
          </button>
        </div>
      </div>
    </div>
  );
};
